export * from './delete-bereich-request.interface';
export * from './delete-bereich-response.interface';
export * from './delete-bereich.shapes';
